import cx from 'classnames';
import { PropsWithChildren } from 'react';

import styles from './table.module.scss';
import { AlignType } from './types';

interface Props extends PropsWithChildren {
  align?: AlignType;
  className?: string;
}

export const TableCell = ({ align, className, children }: Props) => {
  return (
    <td className={cx(styles.cell, className)}>
      <div className={styles[align ?? 'left']}>{children}</div>
    </td>
  );
};
